var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgGroup = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18 4a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2zM6.415 12.707a1 1 0 0 0-1 1v3.878a1 1 0 0 0 1 1h3.877a1 1 0 0 0 1-1v-3.878a1 1 0 0 0-1-1zm7.293 0a1 1 0 0 0-1 1v3.878a1 1 0 0 0 1 1h3.877a1 1 0 0 0 1-1v-3.878a1 1 0 0 0-1-1zM6.415 5.415a1 1 0 0 0-1 1v3.878a1 1 0 0 0 1 1h3.877a1 1 0 0 0 1-1V6.415a1 1 0 0 0-1-1zm7.293 0a1 1 0 0 0-1 1v3.878a1 1 0 0 0 1 1h3.877a1 1 0 0 0 1-1V6.415a1 1 0 0 0-1-1z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGroup);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/group.7cb49207.svg";